// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__3uSzF","input":"style_input__2Jg8q"};